import SocketConnect from "game_play/utils/socket";

class Games extends SocketConnect {
  constructor(ctx, data, urls = window.URLS) {
    super(ctx, urls.ws, urls.games);

    this.set('games', data)
  }

  afterFetch(data) {
    this.set('games', [...data]);
  }

  afterSave(data) {
    this.set('games', this.get('games').map(tournament => {
      if (tournament.id === data.id) {
        return data
      }
      return tournament
    }))
  }

  onSocket(event) {
    super.onSocket();

    switch (event.type) {
      case "update":
        let newGames = event.message
        const games = this.get('games');
        games.forEach((tournament, i) => {
          newGames = newGames.filter((_game) => {
            if (tournament.id === _game.id) {
              games[i] = _game
              return false
            }
            return true
          })
        })
        this.set('games', [...games, ...newGames]);

        break;
      case "delete":
        let ids = event.message
        this.set('games', this.get('games').filter(games => {
          return !ids.includes(games.id)
        }));
        break;
      default:
    }
  }

  formatTime(date) {
    if (!date) return '__:__'
    return new Date(date).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    })
  }
}

export default Games